// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取淘题详情
export function examDtail(data) {
  return request({
    url: "/api/exam/detail",
    method: "post",
    data,
  });
}

// 试题文件下载
export function examFile(data) {
  return request({
    url: "/api/exam/file",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 试题文件下载
export function examFileNoBlob(data) {
  return request({
    url: "/api/exam/file",
    method: "post",
    data,
    // responseType:"blob"
  });
}

// 试题文件下载（展示）
export function examshowFile(data) {
  return request({
    url: "/api/exam/show_file",
    method: "post",
    data,
    // responseType:"blob"
  });
}

// 试题文件下载
export function getBlobByUrl(url, progressFn) {
  return request({
    url: url,
    method: "get",
    responseType: "blob",
    onDownloadProgress: function (progressEvent) {
      // 总长度
      const totalLength = progressEvent.lengthComputable
        ? progressEvent.total
        : null;
      // 当前进度
      const progress = totalLength
        ? (progressEvent.loaded / totalLength) * 100
        : null;
      // 结果数字
      const resultNumber = Number(progress.toFixed(2));
      // 如果有总长度，那么执行里面的代码
      if (progressEvent.lengthComputable) {
        // 如果传递了进度函数，那么执行里面的代码
        if (progressFn) {
          progressFn(resultNumber);
        }
      }
    },
  });
}
